import ApiTruststore, { downloadBlob } from '@/services/ApiTruststore'
import config from '../config'
import axios from 'axios'

export default {
  findAllHost (client) {
    return ApiTruststore().get(`get/host/${client}`)
  },

  findAllStorepass (client) {
    return ApiTruststore().get(`get/client/${client}`)
  },

  downloadJks (client) {
    axios.get(`${config.TRUSTSTORE_BASE_BACKEND_URL}/get/jks/${client}`, {
      responseType: 'blob'
    })
      .then(response => downloadBlob('seniorconnect-truststore' + '.jks', new Blob([response.data])))
  },

  downloadLog (client) {
    return ApiTruststore().get(`get/log/${client}`)
      .then(response => downloadBlob('seniorconnect-truststore' + '.log', new Blob([response.data])))
  },

  insertHost (item) {
    return ApiTruststore().post(`add/host/${item.client}/${item.host}`)
  },

  insertStorepass (item) {
    return ApiTruststore().post(`add/client/${item.client}/${item.storepass}`)
  },

  findById (client, host) {
    const url = `get/host/${client}/${encodeURIComponent(host)}`
    return ApiTruststore().get(url)
  },

  playJks (client) {
    return ApiTruststore().get(`exec/${client}`)
      .then(response => downloadBlob('seniorconnect-truststore' + '.log', new Blob([response.data])))
  }

}
